export interface User {
  wmid: string;
  role: string;
  created_at: string;
  updated_at: string;
}

export class Token {
  constructor(
    public value: string,
    public created_at: string
  ) { }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/services/user.model.ts